function pages_transform(result){
    let ans = result.allMarkdownRemark.edges;
    let a = ans.map((n)=>{
        let nn = page_transform(n.node)
        return nn
    })
    return a
};


function page_transform(node){
    let nn = node.f
    if(node.body){
        nn.body = node.body
    }
    nn.slug = node.fields.slug
    nn.post_id = node.fields.slug.replace(/\/+/g,'');
    nn.excerpt = nn.body
    return nn
};


module.exports={}
module.exports.pages_transform = pages_transform;  
module.exports.page_transform = page_transform;  

